export default __webpack_public_path__ + "static/media/red-square-triangle.889f6f5c.svg";